export const flatteningTemplate = [
  {
    id: 'document_version',
    width: 150,
    header: 'generateReport.dataToResult.report.general.document_version',
  },
  {
    id: 'id_ensaio',
    header: 'generateReport.dataToResult.report.general.id_ensaio',
  },
  {
    id: 'id_hex',
    header: 'generateReport.dataToResult.report.general.id_hex',
  },
  {
    id: 'product',
    width: 230,
    header: 'generateReport.dataToResult.report.general.product',
  },
  {
    id: 'product_version',
    width: 120,
    header: 'generateReport.dataToResult.report.general.product_version',
  },
  {
    id: 'date_started',
    width: 150,
    header: 'generateReport.dataToResult.report.general.date_started',
  },
  {
    id: 'observacao_geral',
    width: 150,
    header: 'generateReport.dataToResult.report.general.observacao_geral',
  },
  {
    id: 'text_comentario',
    width: 150,
    header: 'generateReport.dataToResult.report.general.text_comentario',
  },
  {
    id: 'planta_origem',
    width: 100,
    header: 'generateReport.dataToResult.report.general.planta_origem',
  },
  {
    id: 'data_cadastro',
    width: 400,
    header: 'generateReport.dataToResult.report.general.data_cadastro',
  },
  {
    id: 'data_liberacao_resultado',
    width: 230,
    header:
      'generateReport.dataToResult.report.general.data_liberacao_resultado',
  },
  {
    id: 'amostra_mes',
    width: 230,
    header: 'generateReport.dataToResult.report.general.amostra_mes',
  },
  {
    id: 'desc_cliente',
    header: 'generateReport.dataToResult.report.general.desc_cliente',
  },
  {
    id: 'descricao_mes',
    header: 'generateReport.dataToResult.report.general.descricao_mes',
  },
  {
    id: 'firma_insp',
    width: 230,
    header: 'generateReport.dataToResult.report.general.firma_insp',
  },
  {
    id: 'pedido',
    width: 230,
    header: 'generateReport.dataToResult.report.general.pedido',
  },
  {
    id: 'item',
    header: 'generateReport.dataToResult.report.general.item',
  },
  {
    id: 'corrida',
    header: 'generateReport.dataToResult.report.general.corrida',
  },
  {
    id: 'ordem_de_processo',
    width: 230,
    header: 'generateReport.dataToResult.report.general.ordem_de_processo',
  },
  {
    id: 'lote_tt',
    width: 420,
    header: 'generateReport.dataToResult.report.general.lote_tt',
  },
  {
    id: 'ippn',
    width: 310,
    header: 'generateReport.dataToResult.report.general.ippn',
  },
  {
    id: 'posicao_amostra',
    header: 'generateReport.dataToResult.report.general.posicao_amostra',
  },
  {
    id: 'id_amostra',
    header: 'generateReport.dataToResult.report.general.id_amostra',
  },
  {
    id: 'resultado_ensaio',
    header: 'generateReport.dataToResult.report.general.resultado_ensaio',
  },
]
